module.exports = __webpack_public_path__ + "img/rome.ae3792bc.jpg";